// @flow

import * as React from "react";
import ContextTypes from 'prop-types';
import { Link } from 'react-router';

type Props = {
  to?: string,
  href?: string
};

/// Link class which will opt in to the React router if it's active.
/// Useful for handling links in components which may be shared between
/// router-powered and non-router-powered pages.
export default class RouterableLink extends React.PureComponent<Props> {
  static contextTypes = {
    router: ContextTypes.object
  };

  render() {
    const { to, href, ...props } = this.props;

    // If we've defined a link instead of a href (a link is used to navigate
    // through react-router, instead of a regular href) and context.router is
    // present (which means the routing gear has been activated) then create a
    // react-router link - otherwise, just fallback to a regular href.
    if (to && this.context.router) {
      return <Link to={to} {...props} />;
    }

    return <a href={to || href} {...props} />;
  }
}
